<template lang="html">
  <div class="container" id="text-page">
    <h1 class="page-title txt-black">Aviso de privacidad dirigido a los titulares de datos personales que obran en posesión de ”Extractos EUM”</h1>

    <div v-html="body"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      body:null,
    }
  },
  methods:{
      getHome(){
        axios.get(tools.url("/api/privacidad")).then((response)=>{
            this.body=response.data.body;
          }).catch((error)=>{
        });
      },
  },
  mounted(){
    this.getHome();
  }
}
</script>